import { createFileRoute } from "@tanstack/react-router";
import { RulesContent } from "@/components/RulesContent";

export const Route = createFileRoute("/_app/rules")({
  component: RulesPage,
});

function RulesPage() {
  return <RulesContent />;
}
